import logoSvg from './logo.svg'

import consorcioLogoSvg from './consorcioLogo.svg'

export const SvgImageParceirosBradescoLogo = ( props ) => {
    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
            <img
                className='w-full'
                width="50px"
                height="50px"
                src={logoSvg}
                alt={''}
                {...props}
            />
        </div>
    )
}



export const SvgImageParceirosBradescoConsorcioLogo = ( props ) => {
    return (
        <img
            className='w-full'
            width="50px"
            height="50px"
            src={consorcioLogoSvg}
            alt={''}
            {...props}
        />
    )
}